import { buildPageSeo, isDynamicSeoPath, mergeSeoKeywords } from './siteSeo'

const DESIGN_KW = ['제품 디자인', '산업 디자인', '캐릭터 디자인', 'UI/UX', '브랜드 디자인', '포트폴리오']
const PROJECT_KW = ['구축 사례', '프로젝트 사례', '웹 개발 사례', '앱 개발']
const RECRUIT_KW = ['채용', 'IT 채용', '개발자 채용']

/** @type {Record<string, import('./siteSeo').buildPageSeo extends (...args: infer A) => void ? never : ReturnType<typeof buildPageSeo> | { pageLabel: string, description?: string, keywords?: string | string[], noindex?: boolean, isHome?: boolean }>} */
const PAGE_SEO_ENTRIES = {
    '/': {
        isHome: true,
        description:
            'CODAM(코담)은 기업 맞춤형 웹 플랫폼 구축, AI 기반 업무 자동화, 데이터 플랫폼, 클라우드 인프라, 사이버 보안까지 엔터프라이즈 IT 솔루션을 제공하는 프리미엄 IT 파트너입니다.',
        keywords: [
            '기업 웹 개발',
            '맞춤형 소프트웨어 개발',
            'AI 시스템 구축',
            '데이터 플랫폼 구축',
            '클라우드 구축',
            '엔터프라이즈 시스템 개발',
            '사이버 보안 솔루션',
        ],
    },
    '/software-development': {
        pageLabel: '소프트웨어 개발',
        description:
            'CODAM 소프트웨어 개발: SaaS 플랫폼, 관리자 시스템, API 백엔드, ERP 연동, 데이터 업무 시스템까지 기업 환경에 최적화된 엔터프라이즈 소프트웨어를 구축합니다.',
        keywords: ['SaaS', 'API', 'ERP 연동', '백오피스'],
    },
    '/revenue-management': {
        pageLabel: '매출관리 솔루션',
        description:
            'CODAM 매출관리 솔루션: POS·온라인·배달 매출 통합, 실시간 대시보드, 정산·회계 연동, 본사·가맹 통계까지 기업 매출 운영을 한곳에서 지원합니다.',
        keywords: ['매출관리', 'POS', '정산', '대시보드'],
    },
    '/cyber-security': {
        pageLabel: '사이버 보안',
        description:
            'CODAM 사이버 보안: 웹 보안, 서버·클라우드 보안, 취약점 점검, 데이터 보호, 접근 권한 관리, 보안 운영 체계 구축까지 기업의 디지털 자산을 안전하게 보호합니다.',
        keywords: ['웹 보안', '취약점 점검', '보안 운영', '클라우드 보안'],
    },
    '/about': {
        pageLabel: '코담 컬처',
        description: 'CODAM(코담)의 성장·신뢰·혁신·연결·다양성·지속가능성 등 핵심 가치와 복지·팀 문화를 소개합니다.',
    },
    '/core-values': {
        pageLabel: '핵심 가치',
        description: '코담의 핵심 가치와 일하는 원칙을 정리했습니다. 성장, 신뢰, 혁신, 연결, 다양성, 지속가능성을 바탕으로 협업합니다.',
    },
    '/history': {
        pageLabel: '연혁',
        description:
            '2021년 창립 이후 IT 구축·제품·산업·캐릭터 디자인 포트폴리오와 주요 프로젝트 성과를 연도별로 확인할 수 있습니다.',
        keywords: ['회사 연혁', 'CODAM 연혁'],
    },
    '/how-we-work': {
        pageLabel: '우리가 일하는 방식',
        description: '코담의 협업 원칙, 소통 방식, 리듬을 소개합니다. 핵심 가치와 채용 정보로 이어집니다.',
    },
    '/notices': {
        pageLabel: '공지사항',
        description: 'CODAM 공지사항입니다. 서비스 안내 및 업데이트 소식을 확인할 수 있습니다.',
    },
    '/services': {
        pageLabel: '서비스',
        description:
            'CODAM 서비스: 맞춤형 백오피스, 홈페이지 제작, 이커머스·플랫폼, 소프트웨어·보안·디자인까지 기업 IT 전반을 지원합니다.',
    },
    '/services-details': {
        pageLabel: '서비스 상세',
        description: 'CODAM이 제공하는 IT·디자인 서비스 범위와 진행 방식을 상세히 안내합니다.',
    },
    '/custom-backoffice': {
        pageLabel: '맞춤형 백오피스 시스템',
        description:
            'CODAM 맞춤형 백오피스: 권한·정산·연동·운영까지 엔터프라이즈 수준의 관리자·내부 업무 시스템을 설계·구축합니다.',
        keywords: ['백오피스', '관리자 시스템', '업무 시스템'],
    },
    '/website-creation': {
        pageLabel: '홈페이지 제작',
        description:
            'CODAM 홈페이지 제작: 기업·서비스·랜딩 페이지를 기획·디자인·퍼블리싱·개발까지 일관되게 납품합니다.',
        keywords: ['홈페이지 제작', '기업 홈페이지', '랜딩 페이지'],
    },
    '/ecommerce-platform': {
        pageLabel: '이커머스·플랫폼 개발',
        description:
            'CODAM 이커머스·플랫폼: B2C·B2B·마켓플레이스까지 주문·결제·정산·운영 시스템을 설계·구축합니다.',
        keywords: ['이커머스 개발', '쇼핑몰 구축', 'B2C', 'B2B'],
    },
    '/codam-design': {
        pageLabel: '코담 디자인',
        description:
            'CODAM 디자인: 제품·산업·캐릭터 디자인과 브랜드 IP, UI/UX, 포트폴리오를 한곳에서 살펴볼 수 있습니다.',
        keywords: DESIGN_KW,
    },
    '/codam-design/portfolio': {
        pageLabel: '디자인 포트폴리오',
        description:
            'CODAM 통합 디자인 포트폴리오. 제품·산업·캐릭터 디자인 사례를 연도순으로 확인하고 상세 케이스로 이동할 수 있습니다.',
        keywords: DESIGN_KW,
    },
    '/codam-design/product-design': {
        pageLabel: '제품 디자인',
        description:
            '제품·패키지·프로토타입 디자인 포트폴리오. 카드를 선택하면 케이스 스터디 상세 페이지로 이동합니다.',
        keywords: ['제품 디자인', '패키지 디자인', '프로토타입'],
    },
    '/codam-design/industrial-design': {
        pageLabel: '산업 디자인',
        description:
            '산업·의료 장비 디자인 포트폴리오. 카드를 선택하면 케이스 스터디 상세 페이지로 이동합니다.',
        keywords: ['산업 디자인', '의료기기 디자인', '장비 디자인'],
    },
    '/codam-design/character-design': {
        pageLabel: '캐릭터 디자인',
        description:
            '브랜드 IP·마스코트·캐릭터 디자인 포트폴리오. 코담 공식 마스코트와 클라이언트 IP 사례를 소개합니다.',
        keywords: ['캐릭터 디자인', '마스코트', '브랜드 IP', '일러스트'],
    },
    '/codam-design/character-design/codam-mascot': {
        pageLabel: '코담 브랜드 마스코트',
        description:
            'CODAM 공식 브랜드 마스코트의 턴라운드·포즈 세트·가이드 및 디지털·굿즈 활용을 소개합니다.',
        keywords: ['코담 마스코트', '3D 마스코트', '브랜드 시스템'],
    },
    '/codam-design/character-design/brand-ip-mascot': {
        pageLabel: '브랜드 IP 캐릭터·마스코트 개발',
        description:
            '브랜드 IP·마스코트 캐릭터 기획·제작 사례. 표정·포즈 변형과 웹·SNS·굿즈 활용 가이드를 제공합니다.',
        keywords: ['브랜드 IP', '마스코트 개발', '캐릭터 가이드'],
    },
    '/team': {
        pageLabel: '팀 소개',
        description:
            'CODAM을 이끄는 리더십과 기술·기획·디자인 전문가를 소개합니다. 프로젝트 문의와 협업은 언제든 연락 주세요.',
    },
    '/team-details': {
        pageLabel: '팀원 상세',
        description: 'CODAM 팀 구성원 프로필과 전문 분야를 소개합니다.',
    },
    '/crew-recruit': {
        pageLabel: '함께할 크루 모집',
        description:
            '코담이 함께할 크루를 찾는 기준과 문화를 소개합니다. 엔터프라이즈 IT에 관심 있는 분의 지원을 기다립니다.',
        keywords: RECRUIT_KW,
    },
    '/recruit': {
        pageLabel: '채용',
        description: 'CODAM 채용 안내. 엔터프라이즈 IT·디자인 분야에서 함께할 인재를 모집합니다.',
        keywords: RECRUIT_KW,
    },
    '/job-postings': {
        pageLabel: '채용공고',
        description: '코담 채용 공고 목록입니다. 지원은 문의 페이지로 연결됩니다.',
        keywords: RECRUIT_KW,
    },
    '/project-grid': {
        pageLabel: '구축 사례',
        description:
            'CODAM 구축 사례: 디지털 자산 거래 플랫폼 웹 개발, 블록체인 생태계, B2C 웹·모바일 앱(Android·iOS), 엔터프라이즈 소프트웨어, 보안·IT 등을 분야별 탭으로 살펴보세요.',
        keywords: PROJECT_KW,
    },
    '/project-masonry': {
        pageLabel: '구축 사례 (메이슨리)',
        description:
            'CODAM 구축 사례를 메이슨리 레이아웃으로 살펴보세요. 전체·소프트웨어·웹 보안 등 탭으로 필터링할 수 있으며 그리드 보기와도 연결됩니다.',
        keywords: PROJECT_KW,
    },
    '/contact': {
        pageLabel: '문의하기',
        description:
            'CODAM에 프로젝트를 문의하세요. 기업 웹 플랫폼, AI 시스템, 클라우드 인프라, 사이버 보안까지 비즈니스 환경에 맞는 IT 솔루션 방향을 제안드립니다.',
        keywords: ['프로젝트 문의', '견적 문의', 'IT 컨설팅'],
    },
    '/faq': {
        pageLabel: 'FAQ',
        description: 'CODAM 서비스·프로젝트 진행·지원에 대한 자주 묻는 질문과 답변입니다.',
    },
    '/price': {
        pageLabel: '요금 안내',
        description: 'CODAM IT·디자인 서비스 요금 구조와 상담 안내입니다.',
    },
    '/login': {
        pageLabel: '로그인',
        description: 'CODAM 로그인 페이지입니다.',
        noindex: true,
    },
    '/signup': {
        pageLabel: '회원가입',
        description: 'CODAM 회원가입 페이지입니다.',
        noindex: true,
    },
    '/coming-soon': {
        pageLabel: '준비 중',
        description: 'CODAM — 곧 공개될 페이지입니다.',
        noindex: true,
    },
    '/error': {
        pageLabel: '오류',
        description: '요청하신 페이지를 처리하는 중 오류가 발생했습니다.',
        noindex: true,
    },
    '/blog-grid': {
        pageLabel: '블로그',
        description: 'CODAM 기술·프로젝트·디자인 인사이트 블로그입니다.',
        keywords: ['IT 블로그', '기술 블로그'],
    },
    '/blog-masonry': {
        pageLabel: '블로그 (메이슨리)',
        description: 'CODAM 블로그 글을 메이슨리 레이아웃으로 모아 보실 수 있습니다.',
    },
    '/blog-classic': {
        pageLabel: '블로그 (클래식)',
        description: 'CODAM 블로그 클래식 목록입니다.',
    },
    '/blog-details-v1': {
        pageLabel: '블로그 상세',
        description: 'CODAM 블로그 상세 글입니다.',
    },
    '/blog-details-v2': {
        pageLabel: '블로그 상세',
        description: 'CODAM 블로그 상세 글입니다.',
    },
    '/prepaid-card': {
        pageLabel: '선불카드',
        description: 'CODAM 선불카드·결제 서비스 소개 페이지입니다.',
    },
    '/codam-chain': {
        pageLabel: '코담체인',
        description: '엔터프라이즈급 블록체인 인프라 CODAM Chain을 소개합니다.',
        keywords: ['블록체인', 'Web3', '분산원장'],
    },
    '/codam-pay': {
        pageLabel: '코담페이',
        description: 'CODAM 결제·정산 플랫폼 Codam Pay를 소개합니다.',
        keywords: ['결제', '핀테크', '정산'],
    },
    '/codam-talk': {
        pageLabel: '코담톡',
        description: '조직과 고객을 잇는 엔터프라이즈 메시징·협업 솔루션 코담톡을 소개합니다.',
    },
    '/codam-map': {
        pageLabel: '코담맵',
        description: 'CODAM Map — 위치·지도 기반 서비스 플랫폼을 소개합니다.',
    },
    '/codam-ai-core': {
        pageLabel: '코담 AI 코어',
        description: '엔터프라이즈 LLM·생성형 AI 플랫폼 CODAM AI Core를 소개합니다.',
        keywords: ['생성형 AI', 'LLM', '기업 AI'],
    },
    '/tech-platform': {
        pageLabel: '기술 플랫폼',
        description: 'CODAM 기술 플랫폼·개발 인프라와 연동 체계를 소개합니다.',
    },
    '/developer-center': {
        pageLabel: '개발자 센터',
        description: 'CODAM 개발자 문서·API·SDK 안내 개발자 센터입니다.',
        keywords: ['개발자 센터', 'API 문서'],
    },
    '/codam-dev-summit': {
        pageLabel: '코담 개발자 서밋',
        description: 'CODAM 개발자 컨퍼런스·서밋 일정과 세션을 안내합니다.',
    },
    '/esg': {
        pageLabel: 'ESG',
        description: 'CODAM ESG 경영 방향과 지속가능성 활동을 소개합니다.',
        keywords: ['ESG', '지속가능경영'],
    },
    '/esg-report': {
        pageLabel: 'ESG 보고서',
        description: 'CODAM ESG 보고서와 핵심 지표를 확인할 수 있습니다.',
    },
    '/sme-digitalization': {
        pageLabel: '소상공인 디지털화',
        description: '소상공인·중소기업 디지털 전환 지원 프로그램을 소개합니다.',
    },
    '/active-green': {
        pageLabel: '액티브 그린',
        description: 'CODAM 액티브 그린 — 친환경·지속가능 IT 활동을 소개합니다.',
    },
    '/digital-responsibility': {
        pageLabel: '디지털 책임',
        description: 'CODAM 디지털 윤리·책임 경영 활동을 소개합니다.',
    },
}

/** 404 등 미등록 경로 */
const NOT_FOUND_SEO = {
    pageLabel: '페이지를 찾을 수 없음',
    description: '요청하신 페이지를 찾을 수 없습니다. CODAM 홈 또는 메뉴에서 원하시는 정보를 찾아보세요.',
    noindex: true,
}

/**
 * @param {string} pathname
 * @returns {ReturnType<typeof buildPageSeo> | null} null이면 페이지 컴포넌트가 SEO를 담당
 */
export function resolvePageSeoForPath(pathname) {
    const path = pathname.split('?')[0].split('#')[0] || '/'
    const normalized = path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path

    if (isDynamicSeoPath(normalized)) {
        return null
    }

    if (PAGE_SEO_ENTRIES[normalized]) {
        const entry = PAGE_SEO_ENTRIES[normalized]
        return buildPageSeo({
            ...entry,
            pathname: normalized === '/' ? '/' : normalized,
            keywords: entry.keywords,
        })
    }

    return buildPageSeo({
        ...NOT_FOUND_SEO,
        pathname: normalized,
    })
}

export { mergeSeoKeywords }
